import RelatedItem from '@/src/modules/pg-plus/content/recommendations/RelatedItem'
import { styled } from '@/src/stitches.config'
import { StyledH3 } from '@/src/modules/pg-plus/content/recommendations/StyledComponents'
import { PG_PLUS_SLUG } from '@/prisma/schemaConstants'
import {
    PARTNER_BRAND_PAGE,
    PG_PLUS_BUILD_PAGE,
} from '@/src/modules/pg-plus/constants'

const Wrapper = styled('div', {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 10,
})

type TRecommendProps = {
    trendingItems: [] | null
    hasPartner: boolean
    showGiftIdeasText?: boolean
}

const RecommendedItemsWithoutSearch = ({
    trendingItems,
    hasPartner,
    showGiftIdeasText = false,
}: TRecommendProps) => {
    if (!trendingItems) {
        return <div style={{ marginBottom: 20 }} />
    }

    return (
        <>
            <Wrapper>
                {trendingItems?.map((item: any, index: number) => {
                    if (!item?.logo_url || !item?.slug) {
                        return null
                    }

                    const { logo_url, slug, name } = item
                    const isPgPlus: boolean = slug === PG_PLUS_SLUG
                    const brandPage: string = hasPartner
                        ? `${PARTNER_BRAND_PAGE}/${slug}`
                        : `/brands/${slug}`

                    const adjustedSlug: string = isPgPlus
                        ? PG_PLUS_BUILD_PAGE
                        : brandPage

                    return (
                        <RelatedItem
                            key={name ?? `trending-item-${index}`}
                            image={logo_url}
                            name={name}
                            url={adjustedSlug}
                        />
                    )
                })}
            </Wrapper>
            {/*{showGiftIdeasText && <StyledH3>Gift Ideas:</StyledH3>}*/}
        </>
    )
}

export default RecommendedItemsWithoutSearch
